module.exports = __webpack_public_path__ + "img/game-2.9d07b671.png";